module.exports = __webpack_public_path__ + "static/media/Ex4-S0-SectionBreak.8e382857.PNG";